export class CheckNumberRequestApiModel {
  constructor(public InstanceNumber: string, public FormInstanceId: number, public PhaseId: number = null) {}
}
